import type { ReactNode, MouseEvent } from 'react';
import styles from './style.module.css';

type Props = {
  title: string;
  children: ReactNode;
  actions?: ReactNode;
  onClose: () => void;
};

export function Modal({ title, children, actions, onClose }: Props) {
  function handleOverlayClick(e: MouseEvent) {
    if (e.target === e.currentTarget) onClose();
  }

  return (
    <div className={styles.overlay} role="presentation" onMouseDown={handleOverlayClick}>
      <div className={styles.modal} role="dialog" aria-label={title}>
        <div className={styles.title}>{title}</div>
        {children}
        {actions && <div className={styles.actions}>{actions}</div>}
      </div>
    </div>
  );
}
